import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constants} from '../../shared/config/constants.config';
import {WalletTransactionViewModel} from '../../shared/viewModels/walletTransaction.viewModel';
import {PayoutSettingViewModel} from '../../shared/viewModels/payoutSetting.viewModel';


@Injectable()
export class WalletService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly constants: Constants
    ) {
    }

    getTransactions(skip: number): Observable<WalletTransactionViewModel[]> {
        return this.httpClient.get<WalletTransactionViewModel[]>(`${this.constants.apiURL()}/wallet/transactions/?skip=${skip}`);
    }

    getPayoutSetting(): Observable<PayoutSettingViewModel> {
        return this.httpClient.get<PayoutSettingViewModel>(`${this.constants.apiURL()}/wallet/payout/setting/`);
    }

    updatePayoutSettings(data): Observable<void> {
        return this.httpClient.put<void>(`${this.constants.apiURL()}/wallet/payout/setting/`, data);
    }

}
